import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GraduationCap, Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // On non-home pages, always show solid navbar
  const showSolidNav = scrolled || !isHomePage;
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Programs',
    path: '/programs'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname !== '/') return false;
    return location.pathname.startsWith(path);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${showSolidNav ? 'bg-white/90 backdrop-blur-md shadow-sm py-3 border-b border-gray-200' : 'bg-transparent py-5 border-b border-white/20'}`} data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="flex items-center justify-between" data-id="element-191">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group" data-id="element-192">
            <div className={`p-2 rounded-lg ${showSolidNav ? 'bg-[#1e3a5f] text-white' : 'bg-white text-[#1e3a5f]'}`} data-id="element-193">
              <GraduationCap className="h-6 w-6" data-id="element-194" />
            </div>
            <span className={`text-xl font-bold ${showSolidNav ? 'text-[#1e3a5f]' : 'text-white'} group-hover:opacity-90 transition-opacity`} data-id="element-195">
              Study Board
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-196">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-[#f59e0b] ${isActive(link.path) ? 'text-[#f59e0b]' : showSolidNav ? 'text-gray-700' : 'text-white/90'}`} data-id="element-197">
                {link.name}
              </Link>)}
            <Link to="/apply" data-id="element-198">
              <Button variant="accent" size="sm" data-id="element-199">
                Apply Now
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className={`md:hidden p-2 rounded-md ${showSolidNav ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'}`} onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-200">
            {isOpen ? <X className="h-6 w-6" data-id="element-201" /> : <Menu className="h-6 w-6" data-id="element-202" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Overlay */}
      <AnimatePresence data-id="element-203">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 shadow-lg overflow-hidden" data-id="element-204">
            <div className="px-4 py-6 space-y-4" data-id="element-205">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`block text-base font-medium px-4 py-2 rounded-lg ${isActive(link.path) ? 'bg-[#1e3a5f]/5 text-[#1e3a5f]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-206">
                  {link.name}
                </Link>)}
              <div className="pt-4 px-4" data-id="element-207">
                <Link to="/apply" className="block w-full" data-id="element-208">
                  <Button variant="accent" fullWidth data-id="element-209">
                    Apply Now
                  </Button>
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}